import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { Collapse } from "antd";
import moment from "moment";

import { Modal as AntModal } from "antd";
import { toast } from "react-toastify";
import Modal from "react-modal";
const { Panel } = Collapse;

const GlobalGapForm = (props) => {
  const frmRef = useRef({});

  const [employeeData, setEmployeeData] = useState([]);
  const [employeeId, setEmployeeId] = useState();
  const [plotId, setPlotId] = useState();
  const [plotData, setPlotData] = useState([]);
  const [cropPlotId, setCropPlotId] = useState();
  const [varietyData, setVarietyData] = useState([]);
  const [data, setData] = useState();
  const [justifications, setJustifications] = useState([]);
  const [inspectionDetails, setInspectionDetails] = useState("");
  const [inspectionJson, setInspectionJson] = useState("");

  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);
    //console.log(uniqueID);
    return uniqueID.toString();
  }

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employeeByUsecase/?orgId=${localStorage.getItem(
          "orgId"
        )}&useCase=CommercialFarming`,
      },
      (data) => {
        //console.log(data);
        var emplist = data.output;

        setEmployeeData(emplist);
      }
    );
  }, []);

  const { sendRequest: getPlot } = useHttp();

  useEffect(() => {
    getPlot(
      {
        url: `/api/commercialPlotCompliance/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log(data);
        setPlotData(data);
      }
    );
  }, []);

  const { sendRequest: getVariety } = useHttp();

  useEffect(() => {
    getVariety(
      {
        url: `/api/commercialCropCompliance/?orgId=${localStorage.getItem(
          "orgId"
        )}&plotId=${plotId}`,
      },
      (data) => {
        //console.log(data);
        setVarietyData(data);
      }
    );
  }, [plotId]);

  const { sendRequest: getComplianceHead } = useHttp();

  const getAllData = () => {
    getComplianceHead(
      {
        url: `/api/getSCHeadView/?orgId=${localStorage.getItem(
          "orgId"
        )}&serviceId=1`,
      },
      (res) => {
        //console.log(res);
        if (!props.update) {
          setData(res);
        }
      }
    );
  };

  useEffect(() => {
    getAllData();
  }, []);

  const { sendRequest: postGlobalGap } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const newData = [];
    const transformedData = [];
    //console.log(inspectionJson);

    inspectionJson &&
      inspectionJson.forEach((item) => {
        item.serviceWiseComplianceHeadList.forEach((complianceItem) => {
          transformedData.push({
            globalGapInspectionDetailId: generateUniqueID(),
            createdDate: item.createdDate,
            swcHeadListId: complianceItem.swcHeadListId,
            observation: complianceItem.observation || "",
            justification: complianceItem.justification || "",
          });
        });
      });

    //console.log(transformedData);

    const input = {
      globalGap: [
        {
          globalGapInspectionId: generateUniqueID(),
          inspectionDate: moment(new Date().toISOString().slice(0, 10)).format(
            "DD/MM/YYYY"
          ),
          createdDate: moment(new Date().toISOString()).format(
            "DD/MM/YYYY hh:mm:ss"
          ),

          globalGapInspectionDetails: transformedData,
          cropPlotId: cropPlotId,
          inspectorName: frmRef.current.inspector_name.value,
          inspectorMobileNo: frmRef.current.mob_no.value,
          inspectorEmailId: frmRef.current.email.value,
        },
      ],

      createdBy: parseInt(localStorage.getItem("id")),
      orgId: parseInt(localStorage.getItem("orgId")),
    };

    //console.log(input);

    const newData2 = [];

    inspectionJson &&
      inspectionJson.forEach((item) => {
        item.serviceWiseComplianceHeadList.forEach((complianceItem) => {
          const transformedItem = {
            globalGapInspectionDetailId: item.globalGapInspectionDetailId,

            createdDate: item.createdDate,
            swcHeadListId: complianceItem.swcHeadListId,
            observation: complianceItem.observation,
            justification: complianceItem.justification,
          };

          newData.push(transformedItem);
        });
      });

    const input2 = {
      globalGap: {
        globalGapInspectionId: props.update.globalGapInspectionId,
        inspectionDate: moment(new Date().toISOString().slice(0, 10)).format(
          "DD/MM/YYYY"
        ),
        createdDate: moment(new Date().toISOString()).format(
          "DD/MM/YYYY hh:mm:ss"
        ),
        globalGapInspectionDetails: newData2,
        cropPlotId: cropPlotId,
        inspectorName: frmRef.current.inspector_name.value,
        inspectorMobileNo: frmRef.current.mob_no.value,
        inspectorEmailId: frmRef.current.email.value,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: parseInt(localStorage.getItem("orgId")),
      },
    };

    // //console.log(input2);
    postGlobalGap(
      {
        url: "/api/globalGap/",
        method: props.update ? "PUT" : "POST",
        body: props.update ? input2 : input,
      },
      (data) => {
        //console.log(data);

        toast.success(
          `Global Gap Data ${props.update ? "Updated" : "Added Successfully"}`
        );
        props.addForm(false);
      }
    );
  };

  const { sendRequest: getGlobalGap } = useHttp();

  useEffect(() => {
    if (props.update) {
      //console.log(props.update);
      const Id = props.update.globalGapInspectionId || 0;
      //console.log(Id);

      const parts =
        props.update.inspectionDate && props.update.inspectionDate.split("/");
      if (parts.length === 3) {
        const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
        setSelectedDate(formattedDate);
      }

      getGlobalGap(
        {
          url: `/api/globalGap/?orgId=${localStorage.getItem(
            "orgId"
          )}&globalGapInspectionId=${Id}&editData=edit`,
        },
        (data) => {
          //console.log(data);

          setEmployeeId(data.globalGap && data.globalGap.fieldExecutiveId);

          setPlotId(data.globalGap && data.globalGap.farmerPlotId);
          setCropPlotId(data.globalGap && data.globalGap.cropPlotId);
          frmRef.current.inspector_name.value =
            data.globalGap && data.globalGap.inspectorName;
          frmRef.current.mob_no.value =
            data.globalGap && data.globalGap.inspectorMobileNo;
          frmRef.current.email.value =
            data.globalGap && data.globalGap.inspectorEmailId;
          //console.log(
          //   data.globalGap && data.globalGap.serviceWiseComplianceHeadList
          // );

          setData(
            data.globalGap && data.globalGap.serviceWiseComplianceHeadList
          );
          // setInspectionDetails(data.globalGap && data.globalGap.serviceWiseComplianceHeadList);
        }
      );
    }
  }, [props.update]);

  const handleJustificationChange = (index, itemIndex, justification) => {
    const updatedData = [...data];
    const updatedJustifications = [...justifications];

    updatedJustifications[itemIndex] = {
      // createdDate: moment(new Date().toISOString()).format(
      //   "DD/MM/YYYY hh:mm:ss"
      // ),
      // globalGapInspectionId: generateUniqueID(),
      // swcHeadListId:
      //   data[index].serviceWiseComplianceHeadList[itemIndex].swcHeadListId,
      justification,
    };
    setJustifications(updatedJustifications);

    //console.log(updatedJustifications);

    updatedData[index].serviceWiseComplianceHeadList[itemIndex] = {
      ...updatedData[index].serviceWiseComplianceHeadList[itemIndex],

      justification: updatedJustifications[itemIndex].justification,
      observation: inspectionDetails[itemIndex].observation,
    };

    ////console.log(updatedData);

    setInspectionJson(updatedData);
  };

  useEffect(() => {}, [inspectionDetails, justifications]);

  const handleTextboxChange = (index, itemIndex, observation) => {
    const updatedInspectionDetails = [...inspectionDetails];
    updatedInspectionDetails[itemIndex] = {
      observation,
    };
    //console.log(updatedInspectionDetails);
    setInspectionDetails(updatedInspectionDetails);

    const updatedData = [...data];

    updatedData[index].serviceWiseComplianceHeadList[itemIndex] = {
      ...updatedData[index].serviceWiseComplianceHeadList[itemIndex],
      justification:justifications&& justifications[itemIndex].justification,
      observation: updatedInspectionDetails[itemIndex].observation,
    };
    //console.log(updatedData);

    setInspectionJson(updatedData);
  };

  const handleDropdownChange = (index, itemIndex, selectedOption) => {
    const updatedInspectionDetails = [...inspectionDetails];
    updatedInspectionDetails[itemIndex] = {
      observation: selectedOption,
    };
    setInspectionDetails(updatedInspectionDetails);
    ////console.log(updatedInspectionDetails);

    const updatedData = [...data];

    updatedData[index].serviceWiseComplianceHeadList[itemIndex] = {
      ...updatedData[index].serviceWiseComplianceHeadList[itemIndex],
      justification:justifications&& justifications[itemIndex].justification,
      observation: updatedInspectionDetails[itemIndex].observation,
    };
    //console.log(updatedData);

    setInspectionJson(updatedData);
  };

  const handleRadioButtonChange = (index, itemIndex, selectedOption) => {
    const updatedInspectionDetails = [...inspectionDetails];
    updatedInspectionDetails[itemIndex] = {
      observation: selectedOption,
    };
    setInspectionDetails(updatedInspectionDetails);
    //console.log(updatedInspectionDetails);

    const updatedData = [...data];

    updatedData[index].serviceWiseComplianceHeadList[itemIndex] = {
      ...updatedData[index].serviceWiseComplianceHeadList[itemIndex],
      justification:justifications&& justifications[itemIndex].justification,
      observation: updatedInspectionDetails[itemIndex].observation,
    };
    //console.log(updatedData);

    setInspectionJson(updatedData);
  };

  const isGreen = (index) => {
    return (
      (inspectionDetails &&
        inspectionDetails.some((item) => !!item.observation)) ||
      (justifications && justifications.length > 0)
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form  onSubmit={submitHandler}>
           
                <div className="card-header">
                  <h3 className="card-title">Global Gap Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"executive_name"}>
                        {"Field Executive"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        required
                        onChange={(e) => {
                          setEmployeeId(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option key={x.userId} value={x.userId}>
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"plot_name"}>{"Plot Name"}</label>

                      <select
                        id="plot_name"
                        className="form-control"
                        ref={(el) => (frmRef.current["plot_name"] = el)}
                        required
                        value={plotId}
                        onChange={(e) => {
                          setPlotId(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {plotData &&
                          plotData.map((x) => (
                            <option key={x.plotId} value={x.plotId}>
                              {x.plotName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"crop_variety"}>{"Crop Variety"}</label>
                      <select
                        id="crop_variety"
                        className="form-control"
                        ref={(el) => (frmRef.current["crop_variety"] = el)}
                        value={cropPlotId}
                        required
                        onChange={(e) => {
                          setCropPlotId(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {varietyData &&
                          varietyData.map((x) => (
                            <option key={x.cropPlotId} value={x.cropPlotId}>
                              {x.cropVarietyName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"inspector_name"}>
                        {"Inspector Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"inspector_name"}
                        required
                        ref={(el) => (frmRef.current["inspector_name"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"mob_no"}>{"Inspector Mobile No"}</label>
                      <input
                        type={"text"}
                        id={"mob_no"}
                        required
                        autoComplete="off"
                        ref={(el) => (frmRef.current["mob_no"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"mob_no"}>{"Inspector EmailId"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="mt-3 mb-2">
                    {data &&
                      data.map((x, index) => (
                        <>
                          <Collapse>
                            <Panel
                              header={x.complianceHeadName}
                              key={index + 1}
                              // className={isGreen(index) ? "panel-green" : "panel-orange"}
                            >
                              {x.serviceWiseComplianceHeadList &&
                                x.serviceWiseComplianceHeadList.map(
                                  (m, itemIndex) => (
                                    <>
                                      <b htmlFor={"accordion_label"}>
                                        {m.complianceFieldName}
                                      </b>{" "}
                                      <br />
                                      <br />
                                      {m.controlType === "RadioButton" ? (
                                        <>
                                          <label>observation:</label>
                                          {m.itemList &&
                                            m.itemList.map((item, ii) => (
                                              <label key={ii}>
                                                <input
                                                  type="radio"
                                                  value={item}
                                                  checked={
                                                    inspectionDetails &&
                                                    inspectionDetails[itemIndex]
                                                      ?.observation === item
                                                  }
                                                  onChange={(e) =>
                                                    handleRadioButtonChange(
                                                      index,
                                                      itemIndex,
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                                {item}
                                              </label>
                                            ))}
                                        </>
                                      ) : m.controlType === "TextBox" ? (
                                        <>
                                          <label>Observation:</label>
                                          <input
                                            type="text"
                                            value={
                                              (inspectionDetails &&
                                                inspectionDetails[itemIndex]
                                                  ?.observation) ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleTextboxChange(
                                                index,
                                                itemIndex,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </>
                                      ) : m.controlType === "List" ? (
                                        <>
                                          <label htmlFor={"dropdown"}>
                                            observation:
                                          </label>
                                          <select
                                            className="form-control"
                                            value={
                                              inspectionDetails &&
                                              inspectionDetails[itemIndex]
                                                ?.observation
                                            }
                                            onChange={(e) =>
                                              handleDropdownChange(
                                                index,
                                                itemIndex,
                                                e.target.value
                                              )
                                            }
                                          >
                                            <option value="">
                                              Select an option
                                            </option>
                                            {m.itemList &&
                                              m.itemList.map((item, iIndex) => (
                                                <option
                                                  key={iIndex}
                                                  value={item}
                                                >
                                                  {item}
                                                </option>
                                              ))}
                                          </select>
                                        </>
                                      ) : null}
                                      <br />
                                      <br />
                                      <div className="">
                                        <label htmlFor={"accordion_label"}>
                                          {"Justification"} &nbsp;
                                          <input
                                            type="text"
                                            id="justification"
                                            value={
                                              (justifications &&
                                                justifications[itemIndex]
                                                  ?.justification) ||
                                              ""
                                            }
                                            onChange={(e) =>
                                              handleJustificationChange(
                                                index,
                                                itemIndex,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </label>{" "}
                                      </div>
                                      <br />
                                    </>
                                  )
                                )}
                            </Panel>
                          </Collapse>
                          <br />
                        </>
                      ))}
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
                
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default GlobalGapForm;
